import React from 'react';
import { Tab } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import IntegrationForm from 'Containers/Modal/IntegrationModal/IntegrationForm';

const IntegrationFormModal = ({
  show,
  onHide,
  availableIntegrations = [],
  tabKey,
  updatedIntegration,
  onSubmit,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="integration-form-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="integration-form-modal">
          <div className="d-flex justify-content-left align-items-center gap-2">
            <img
              src={`/Images/logo-${tabKey.toLowerCase()}.png`}
              alt={tabKey}
              width="28"
              height="28"
            />
            <h5>{tabKey} integration</h5>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container activeKey={tabKey}>
          <Tab.Content>
            {availableIntegrations.map((integration) => (
              <Tab.Pane eventKey={integration.type} key={integration.type}>
                <IntegrationForm
                  type={integration.type.toLowerCase()}
                  fields={integration.fields}
                  defaultValues={updatedIntegration}
                  onSubmit={(type, values) => {
                    onSubmit(type, values);
                  }}
                />
              </Tab.Pane>
            ))}
          </Tab.Content>
        </Tab.Container>
      </Modal.Body>
    </Modal>
  );
};

export default IntegrationFormModal;
